import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const METERS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    ADMIN_METERS: (orderID: number) => `/admin-meters/${orderID}/`,
    ADMIN_DEL_METER: (meterID: number) => `/admin-del-meter/${meterID}/`,
    ADMIN_METER: (orderID: number) => `/admin-meter/${orderID}/`,
  }),
} as const;
